/**
 * Scoring system — milestone 1 subset.
 *
 * Per docs/PLAN.md §4.7:
 *   score = sum(catBaseValue) + heightBonus(maxHeight)
 * Restlessness multiplier and bonus cats land in milestone 2/3.
 *
 * Pure math, fully deterministic, easy to unit test.
 */

const HEIGHT_BONUS_PER_UNIT = 0.5;

/**
 * Compute the run score from the placed-cat count and the highest-cat
 * y-coordinate (in world units, with y growing upward from the bed).
 */
export function computeScore(catCount: number, maxHeightWorldUnits: number): number {
  const catScore = catCount;
  const heightBonus = Math.max(0, maxHeightWorldUnits) * HEIGHT_BONUS_PER_UNIT;
  return Math.round((catScore + heightBonus) * 10);
}

/**
 * Compute "stack height" reported in the HUD. We subtract the bed height
 * and clamp at zero so a cat sitting on the bed reports a height of 0.
 */
export function stackHeight(highestCatY: number, bedSurfaceY: number): number {
  return Math.max(0, highestCatY - bedSurfaceY);
}
